
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor04Flat as ObiBipolar_transistor04FlatElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-04-flat.js';
 
 
 

 
 export const ObiBipolar_transistor04Flat = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-04-flat',
   elementClass: ObiBipolar_transistor04FlatElement,
   events: {
     
   }
  });
 
 